import {ModalAction} from './ItemMasterInterfaces';

const headersMap: {[key: string]: {[key: string]: string}} = {
  sku: {header: 'sku (required)', value1: 'SKU-A', value2: 'SKU-B'},
  description: {
    header: 'description (optional)',
    value1: 'Example inventory description A',
    value2: 'Example inventory description B'
  },
  cartonShipAlone: {header: 'carton_ship_alone (optional)', value1: 'FALSE', value2: 'TRUE'},
  cartonShipAsIs: {header: 'carton_ship_as_is (optional)', value1: 'FALSE', value2: 'TRUE'},
  eachShipAlone: {header: 'each_ship_alone (optional)', value1: 'TRUE', value2: 'TRUE'},
  eachShipAsIs: {header: 'each_ship_as_is (optional)', value1: 'FALSE', value2: 'TRUE'},
  alternateId: {header: 'alternate_id (optional)', value1: '1234-ABCD', value2: '5678-EFGH'},
  cartonsPerLayer: {header: 'cartons_per_layer (optional)', value1: '4', value2: '8'},
  layersPerPallet: {header: 'layers_per_pallet (optional)', value1: '3', value2: '2'},
  cartonsPerPallet: {header: 'cartons_per_pallet (optional)', value1: '12', value2: '16'},
  cartonsPerParent: {header: 'cartons_per_parent (optional)', value1: '12', value2: '16'},
  stackable: {header: 'stackable (optional)', value1: 'TRUE', value2: 'TRUE'},
  inventoryGroup: {header: 'inventory_group (optional)', value1: 'Medium', value2: 'Small'},
  palletLength: {header: 'pallet_length (optional)', value1: '48', value2: '48'},
  palletWidth: {header: 'pallet_width (optional)', value1: '48', value2: '48'},
  palletHeight: {header: 'pallet_height (optional)', value1: '54', value2: '54'},
  palletDimensionUnit: {header: 'pallet_dimension_unit (optional)', value1: 'in', value2: 'in'},
  palletWeight: {header: 'pallet_weight (optional)', value1: '207', value2: '100'},
  palletWeightUnit: {header: 'pallet_weight_unit (optional)', value1: 'lb', value2: 'lb'},
  cartonLength: {header: 'carton_length (optional)', value1: '20', value2: '15'},
  cartonWidth: {header: 'carton_width (optional)', value1: '10', value2: '7'},
  cartonHeight: {header: 'carton_height (optional)', value1: '7', value2: '3'},
  cartonDimensionUnit: {header: 'carton_dimension_unit (optional)', value1: 'in', value2: 'in'},
  cartonWeight: {header: 'carton_weight (optional)', value1: '10.4', value2: '5.1'},
  cartonWeightUnit: {header: 'carton_weight_unit (optional)', value1: 'lb', value2: 'lb'},
  cartonBarcode: {header: 'carton_barcode (optional)', value1: 'ABCDEFGHI123', value2: 'IHGFEDCBA321'},
  cartonBarcodeType: {header: 'carton_barcode_type (optional)', value1: 'UPC', value2: 'UPC'},
  eachLength: {header: 'each_length (optional)', value1: '5', value2: '5'},
  eachWidth: {header: 'each_width (optional)', value1: '9', value2: '6'},
  eachHeight: {header: 'each_height (optional)', value1: '6', value2: '2.8'},
  eachDimensionUnit: {header: 'each_dimension_unit (optional)', value1: 'in', value2: 'in'},
  eachWeight: {header: 'each_weight (optional)', value1: '14.1', value2: '7.3'},
  eachWeightUnit: {header: 'each_weight_unit (optional)', value1: 'lb', value2: 'lb'},
  eachesPerParent: {header: 'eaches_per_parent (optional)', value1: '4', value2: '3'},
  eachesPerCarton: {header: 'eaches_per_carton (optional)', value1: '4', value2: '3'},
  eachBarcode: {header: 'each_barcode (optional)', value1: 'LM3456789123', value2: 'JK1987654321'},
  eachBarcodeType: {header: 'each_barcode_type (optional)', value1: 'UPC', value2: 'UPC'},
  eachSerialNumberCaptureMode: {
    header: 'each_serial_number_capture_mode (optional)',
    value1: 'OUTBOUND_CAPTURE',
    value2: 'NONE'
  },
  eachSerialNumberPatterns: {
    header: 'each_serial_number_patterns (optional)',
    value1: '"LLNN,NN-LLL,LLLL"',
    value2: ''
  },
  innerPackItem: {header: 'inner_pack_item', value1: 'TRUE', value2: 'FALSE'},
  innerPackShipAlone: {header: 'inner_pack_ship_alone (optional)', value1: 'TRUE', value2: ''},
  innerPackShipAsIs: {header: 'inner_pack_ship_as_is (optional)', value1: 'FALSE', value2: ''},
  innerPackLength: {header: 'inner_pack_length (optional)', value1: '5', value2: ''},
  innerPackWidth: {header: 'inner_pack_width (optional)', value1: '9', value2: ''},
  innerPackHeight: {header: 'inner_pack_height (optional)', value1: '6', value2: ''},
  innerPackDimensionUnit: {header: 'inner_pack_dimension_unit (optional)', value1: 'in', value2: ''},
  innerPackWeight: {header: 'inner_pack_weight (optional)', value1: '14.1', value2: ''},
  innerPackWeightUnit: {header: 'inner_pack_weight_unit (optional)', value1: 'lb', value2: ''},
  innerPackPerParent: {header: 'inner_packs_per_parent (optional)', value1: '4', value2: '3'},
  innerPackBarcode: {header: 'inner_pack_barcode (optional)', value1: 'LM3456789124', value2: ''},
  innerPackBarcodeType: {header: 'inner_pack_barcode_type (optional)', value1: 'UPC', value2: ''},
  hazmat: {header: 'hazmat (optional)', value1: '', value2: ''},
  pkgCode: {header: 'pkg_code (optional)', value1: '', value2: ''},
  unNumber: {header: 'un_number (optional)', value1: '', value2: ''},
  limitedQuantity: {header: 'limited_quantity (optional)', value1: '', value2: ''},
  lotCodeTrackingEnabled: {header: 'lot_code_tracking_enabled (optional)', value1: '', value2: ''},
  expiryDateTrackingEnabled: {header: 'expiry_date_tracking_enabled (optional)', value1: '', value2: ''},
  bagAndTapeRequired: {header: 'bag_and_tape_required (optional)', value1: '', value2: ''},
  velocity: {header: 'velocity (optional)', value1: '', value2: ''},
  releaseDate: {header: 'release_date (optional)', value1: '', value2: ''},
  serialNumberProgram: {header: 'serial_number_program (optional)', value1: '', value2: ''},
  countryOfOrigin: {header: 'country_of_origin (optional)', value1: '', value2: 'MX'},
  hsCode: {header: 'hs_code (optional)', value1: '', value2: '123456'},
  shelfLifeThreshold: {header: 'shelf_life_threshold (optional)', value1: '', value2: '1'},
  newSku: {header: 'new_sku (optional)', value1: 'SKU-A2', value2: ''}
};

export const createCsv = (
  isShipper: boolean,
  action: ModalAction,
  showImsAlternateId: boolean,
  useReleaseDate: boolean,
  useSerialNumberProgram: boolean,
  imsBulkUpsertEnabled: boolean,
  imsEnableInnerPack: boolean,
  innerPackCsvEnabled: boolean
) => {
  const headers = headersMap;
  if (!showImsAlternateId) {
    delete headers.alternateId;
  }

  if (!useReleaseDate) {
    delete headers.releaseDate;
  }

  if (useSerialNumberProgram) {
    delete headers.eachSerialNumberCaptureMode;
    delete headers.eachSerialNumberPatterns;
  } else {
    delete headers.serialNumberProgram;
  }

  if (!imsBulkUpsertEnabled) {
    delete headers.newSku;
  }

  if (!imsBulkUpsertEnabled || !imsEnableInnerPack || !innerPackCsvEnabled) {
    delete headers.innerPackItem;
    delete headers.innerPackShipAlone;
    delete headers.innerPackShipAsIs;
    delete headers.innerPackPerParent;
    delete headers.innerPackLength;
    delete headers.innerPackWidth;
    delete headers.innerPackHeight;
    delete headers.innerPackDimensionUnit;
    delete headers.innerPackWeight;
    delete headers.innerPackWeightUnit;
    delete headers.innerPackPerParent;
    delete headers.innerPackBarcode;
    delete headers.innerPackBarcodeType;
    delete headers.cartonsPerParent;
    delete headers.eachesPerParent;
  } else {
    delete headers.cartonsPerPallet;
    delete headers.eachesPerCarton;
  }

  const headerValues = Object.values(headers).map((h) => (typeof h === 'string' ? h : h.header));
  const exampleRow1 = Object.values(headers).map((h) => (typeof h === 'string' ? '' : h.value1));
  const exampleRow2 = Object.values(headers).map((h) => (typeof h === 'string' ? '' : h.value2));

  const csvRows = [headerValues.join(','), exampleRow1.join(','), exampleRow2.join(',')];

  const blob = new Blob([csvRows.join('\n')], {type: 'text/csv;charset=utf-8;'});
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = 'InventoryCsvTemplate.csv';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(url);
};
